import React from 'react'
import { string, shape, object, number, bool } from 'prop-types'
import config from '../../config'

export const ProfilePicture = ({ picture, style, rounded, centered, className, size, title }) => (
  <img
    style={size ? { maxWidth: `${size}px`, maxHeight: `${size}px`, ...style } : { ...style }}
    className={
        (rounded ? ' img--rounded ' : '') +
        (centered ? ' img--centered ' : '') +
        (className || '')
    }
    src={picture && picture.path !== '' ? picture.path : config.profile_image_default}
    alt={title}
    title={title} />
)

ProfilePicture.propTypes = {
  picture: shape({ path: string }),
  size: number,
  style: object,
  rounded: bool,
  centered: bool,
  className: string,
  title: string
}

ProfilePicture.defaultProps = {
  title: 'Photo de profil',
  picture: { path: '' }
}



// WEBPACK FOOTER //
// ./src/components/ui/ProfilePicture.js